export const version = '0.539.0'
export const chameleonWebVersion = '3.37.1'
export const chameleonCoreVersion = '3.0.2'
